import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';
import copy from 'copy-to-clipboard';

export default class Password extends Component {
  static propTypes = {
    password: PropTypes.string.isRequired,
  }
  state = {
    isPasswordVisible: false,
  }

  @autobind
  handleShowPassword() {
    this.setState({ isPasswordVisible: true });
  }

  @autobind
  handlePasswordToClipboard() {
    copy(this.props.password);
  }

  render() {
    const { password } = this.props;

    return (
      <div>
        {
          this.state.isPasswordVisible &&
            <span>
              {password}&nbsp;
              <button className="link" onClick={this.handlePasswordToClipboard}>
                Copy to clipboard
              </button>
            </span>
        }
        {!this.state.isPasswordVisible &&
          <button className="link" onClick={this.handleShowPassword}>
            Show
          </button>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Password.jsx